"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomerSubscriptionBusiness {
    constructor(dateTimeBridge) {
        this.sortSubscriptionsByCurrentSubscription = (subscriptions, currentSubscriptionId) => {
            const current = this.findSubscriptionBySubscriptionId(subscriptions, currentSubscriptionId);
            const previousSubscriptions = this.filterPreviousSubscription(subscriptions, current === null || current === void 0 ? void 0 : current.start);
            const nextSubscriptions = this.filterNextSubscriptions(subscriptions, current === null || current === void 0 ? void 0 : current.end);
            return {
                current: this.rawSubscriptionToUserSubscription(current),
                previous: previousSubscriptions
                    .sort(this.sortSubscriptions(true))
                    .map(this.rawSubscriptionToUserSubscription),
                next: nextSubscriptions
                    .sort(this.sortSubscriptions(false))
                    .map(this.rawSubscriptionToUserSubscription),
            };
        };
        this.sortSubscriptions = (isDescending) => (a, b) => {
            const startTimeA = new Date(a.start).getTime();
            const startTimeB = new Date(b.start).getTime();
            return isDescending ? startTimeB - startTimeA : startTimeA - startTimeB;
        };
        this.findSubscriptionBySubscriptionId = (subscriptions, subscriptionId) => subscriptions.find((subscription) => subscription.subscriptionId === subscriptionId);
        this.filterPreviousSubscription = (subscriptions, currentSubscriptionStartDate) => subscriptions.filter((subscription) => {
            const subscriptionEndTime = new Date(subscription.end).getTime();
            const currentSubscriptionStartTime = new Date(currentSubscriptionStartDate).getTime();
            return subscriptionEndTime < currentSubscriptionStartTime;
        });
        this.filterNextSubscriptions = (subscriptions, currentSubscriptionEndDate) => subscriptions.filter((subscription) => {
            const subscriptionStartTime = new Date(subscription.start).getTime();
            const currentSubscriptionEndTime = new Date(currentSubscriptionEndDate).getTime();
            return subscriptionStartTime > currentSubscriptionEndTime;
        });
        this.rawSubscriptionToUserSubscription = (rawSubscription) => {
            return {
                startDate: this.dateTimeBridge.userDate(rawSubscription === null || rawSubscription === void 0 ? void 0 : rawSubscription.start),
                endDate: this.dateTimeBridge.userDate(rawSubscription === null || rawSubscription === void 0 ? void 0 : rawSubscription.end),
                planName: rawSubscription.plan.name,
                subscriptionLength: rawSubscription.duration,
                coachName: rawSubscription.coach && rawSubscription.coach.name,
                subscriptionType: rawSubscription.subscriptionType,
                location: rawSubscription.trainingLocation.placeName,
                locationName: rawSubscription.trainingLocation.details,
                coachingDays: rawSubscription.coachingDays,
            };
        };
        this.dateTimeBridge = dateTimeBridge;
    }
}
exports.default = CustomerSubscriptionBusiness;
//# sourceMappingURL=CustomerSubscriptionBusiness.js.map